import { render, staticRenderFns } from "./StatisticProjectReportsModal.vue?vue&type=template&id=422e8459&scoped=true&"
import script from "./StatisticProjectReportsModal.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsModal.vue?vue&type=script&lang=js&"
import style0 from "./StatisticProjectReportsModal.vue?vue&type=style&index=0&id=422e8459&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e8459",
  null
  
)

export default component.exports